(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GpfsBatchDialogController', GpfsBatchDialogController);

    GpfsBatchDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GpfsBatch'];

    function GpfsBatchDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GpfsBatch) {
        var vm = this;

        vm.gpfsBatch = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gpfsbatches = GpfsBatch.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gpfsBatch.id !== null) {
                GpfsBatch.update(vm.gpfsBatch, onSaveSuccess, onSaveError);
            } else {
                GpfsBatch.save(vm.gpfsBatch, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:gpfsBatchUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.batchDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
